import { isEnglish } from './i18n'
import { formatDisplayDate } from './dateDisplay'

/** A date or date-time as the screen writes it — see dateDisplay.js (Taiga #1538). */
export const displayDate = (value) => formatDisplayDate(value, { english: isEnglish })
